module.exports = __webpack_public_path__ + "img/album12_12.952ca7b3.jpg";